/*
 * Copyright (c) 2020.
 *
 * Robert Siennicki (rs@bananahouse.pl)
 * http://bananahouse.pl
 */

let PluginFloatingLabel = new function(){
    var me = this;

    this.init = function(obj){
        obj.find('[data-plugin-floating-label], [data-plugin-floating-label-group] .form-group').each(function(){
            var el = $(this);
            var options = el.data('widget-floating-label');

            var defaults = {
                populatedClass : 'populated',
                focusedClass : 'focused'
            };

            var settings = $.extend({}, defaults, options);

            var label = el.find('label'),
                input = el.find('textarea, input');

            if( !input.attr('placeholder') ) {
                input.attr('placeholder', label.text());
            }

            if(input.val() != '') {
                el.addClass( settings.populatedClass );
            }

            input.on( 'focus', function(){
                el.addClass( settings.focusedClass );

                if( input.val() != '' ){
                    el.addClass( settings.populatedClass );
                }
            });

            input.on( 'blur', function(){
                el.removeClass( settings.focusedClass );

                if( input.val() == '' ){
                    el.removeClass( settings.populatedClass );
                }
            });

            input.on( 'keyup', function(){
                if( input.val() != '' ){
                    el.addClass( settings.populatedClass );
                }
            });
        });
    };
};

module.exports = PluginFloatingLabel;